import { inject, Injectable } from "@angular/core";
import { HttpClient, HttpEvent, HttpEventType } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { EntityApiService } from "../../../../shared/store/entity-store/entity-api.service";
import { environment } from "../../../../../environments/environment";
import { FileType } from "../../models/file-type";

interface UploadProgress<T> {
  progress: number;
  file?: T;
}

@Injectable({ providedIn: "root" })
export class DocumentApiService implements EntityApiService<FileType> {
  httpClient = inject(HttpClient);

  loadOne(id: string): Observable<FileType> {
    return this.httpClient.get<FileType>(`${environment.docApi()}/files/${id}`);
  }

  create(entity: FileType): Observable<FileType> {
    throw new Error("Method not implemented.");
  }

  remove(id: string): Observable<string> {
    throw new Error("Method not implemented.");
  }

  update(entity: FileType): Observable<FileType> {
    throw new Error("Method not implemented.");
  }

  loadAll(): Observable<FileType[]> {
    throw new Error("Method not implemented.");
  }

  uploadFile(file: File): Observable<UploadProgress<FileType>> {
    const formData = new FormData();
    formData.append("file", file);

    return this.httpClient
      .post<FileType>(`${environment.docApi()}/files/upload`, formData, {
        reportProgress: true,
        observe: "events",
      })
      .pipe(map((event) => this.mapEventToProgress(event)));
  }

  private mapEventToProgress(
    event: HttpEvent<FileType>,
  ): UploadProgress<FileType> {
    switch (event.type) {
      case HttpEventType.UploadProgress:
        const progress = event.total
          ? Math.round((100 * event.loaded) / event.total)
          : 0;
        return { progress };
      case HttpEventType.Response:
        return { progress: 100, file: event.body };
      case HttpEventType.DownloadProgress:
      case HttpEventType.ResponseHeader:
        return { progress: 100 };
      default: {
        return { progress: 0 };
      }
    }
  }
}
